const PREFIX_RESET = "clictoeat_dashboard_reset_v1_";
const PREFIX_ARCHIVES = "clictoeat_dashboard_archives_v1_";
const MAX_ARCHIVES = 25;

function scopeKey(scopeId) {
  return String(scopeId || "default");
}

export function getDashboardResetSince(scopeId) {
  if (!scopeId) return null;
  return localStorage.getItem(PREFIX_RESET + scopeKey(scopeId));
}

export function setDashboardResetSince(scopeId, isoString) {
  if (!scopeId) return;
  localStorage.setItem(PREFIX_RESET + scopeKey(scopeId), isoString);
}

export function getDashboardArchives(scopeId) {
  if (!scopeId) return [];
  try {
    const raw = localStorage.getItem(PREFIX_ARCHIVES + scopeKey(scopeId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function pushDashboardArchive(scopeId, entry) {
  if (!scopeId) return;
  const list = getDashboardArchives(scopeId);
  list.unshift(entry);
  localStorage.setItem(
    PREFIX_ARCHIVES + scopeKey(scopeId),
    JSON.stringify(list.slice(0, MAX_ARCHIVES))
  );
}

export function filterOrdersSinceReset(orders, resetSinceISO) {
  if (!resetSinceISO || !Array.isArray(orders)) return orders || [];
  const t = new Date(resetSinceISO).getTime();
  if (Number.isNaN(t)) return orders;
  return orders.filter((o) => {
    if (!o?.createdAt) return false;
    const ct = new Date(o.createdAt).getTime();
    return !Number.isNaN(ct) && ct >= t;
  });
}
